var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitorTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3251_1438)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 40H276C281.304 40 286.391 42.1071 290.142 45.8579C293.893 49.6086 296 54.6957 296 60V180C296 185.304 293.893 190.391 290.142 194.142C286.391 197.893 281.304 200 276 200H136C130.696 200 125.609 197.893 121.858 194.142C118.107 190.391 116 185.304 116 180V60C116 54.6957 118.107 49.6086 121.858 45.8579C125.609 42.1071 130.696 40 136 40ZM136 80V120H196V80H136ZM216 80V120H276V80H216ZM136 140V180H196V140H136ZM216 140V180H276V140H216Z",
    fill: "var(--card-thumbnail-fg)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3251_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-fg)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3251_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(24 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3251_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(366 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3251_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(372 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3251_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(320 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3251_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(326 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorTable);
export default __webpack_public_path__ + "static/media/monitor-table.6630248fcdd9af466c1c1fb5514ce5fe.svg";
export { ForwardRef as ReactComponent };